import { useEffect, useState } from "react";
import { Boxes, Search } from "lucide-react";
import { fetchStock } from "@/lib/bf";

const DemoTag = () => <em className="bf-demo-tag" data-testid="bf-demo-tag">date de probă</em>;

export default function BFStockTotal({ admin = false, firms = [] }) {
  const [q, setQ] = useState("");
  const [rows, setRows] = useState(null);
  useEffect(() => {
    const t = setTimeout(() => fetchStock(q).then(setRows).catch(() => setRows([])), 300);
    return () => clearTimeout(t);
  }, [q]);
  const fname = (id) => firms.find((f) => f.id === id)?.name || id;
  return (
    <section className="invite-box" data-testid="bf-stock">
      <h3><Boxes size={18} /> Stoc {admin ? "pe firme" : "disponibil"} <DemoTag /></h3>
      <p className="st-hint">{admin ? "Stocul fiecărei firme și data celui mai vechi lot. Se vinde întâi lotul cel mai vechi, din orice firmă." : "Stocul total disponibil pentru comenzi."}</p>
      <label className="bf-stock-search"><Search size={15} /><input placeholder="Caută produs sau cod" value={q} onChange={(e) => setQ(e.target.value)} data-testid="bf-stock-search" /></label>
      {!rows && <p className="st-hint">Se încarcă…</p>}
      {rows && !rows.length && <p className="st-hint" data-testid="bf-stock-empty">Niciun produs găsit.</p>}
      <ul className="bf-stock-list">
        {(rows || []).map((r) => (
          <li key={r.code} data-testid={`bf-stock-row-${r.code}`}>
            <div><b>{r.name}</b><small>cod {r.code}</small></div>
            {admin && <div className="bf-stock-firms">{Object.entries(r.firms || {}).map(([f, v]) => <span key={f}>{fname(f)}: <b>{v.left}</b> · din {v.oldest.split("-").reverse().join(".")}</span>)}</div>}
            <strong className={r.total ? "is-in" : "is-out"} data-testid={`bf-stock-total-${r.code}`}>{r.total ? `${r.total} buc.` : "stoc epuizat"}</strong>
          </li>
        ))}
      </ul>
    </section>
  );
}

export { DemoTag };
